import React from "react";

const AppDownloadBanner = () => (
  <div className="flex justify-center items-center py-3">
    <a
      href="https://play.google.com/store/apps/details?id=com.tricles.bluewasherapp"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-3 bg-gray-100 border border-gray-300 rounded-xl px-4 py-2 shadow hover:shadow-md transition"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
        alt="Get it on Google Play"
        className="h-10"
      />
      <span className="text-sm text-gray-700 font-medium">
        Download Blue Washer App
      </span>
    </a>
  </div>
);

export default AppDownloadBanner;
